class HgsTemplateLoader {
  hid: string;

  constructor() {
    const content =
      document.querySelector<HTMLMetaElement>("meta[name=hid]")?.content ?? "";
    // Sanitize: valid hospital IDs are never longer than 10 characters
    this.hid = content.length <= 10 ? content : "";
  }

  /** This function executes all template processes */
  cleanPage() {
    this.setupHospitalSelection(this.hid);
  }

  setupHospitalSelection(hid: string) {
    if (hid) {
      // Cart reads wait on this: on a first visit (no session cookie) a parallel cart call
      // would start its own session, and whichever cookie lands last could drop the hospital
      window.hgsHospitalSelection = fetch(
        `/api/session/hospital/?id=${encodeURIComponent(hid)}`
      ).catch(() => undefined);
    }
  }
}

const loader = new HgsTemplateLoader();
loader.cleanPage();

export {};
